import React from "react";
import { Box, Flex, Text, Icon, Stack, Heading } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { FiCamera, FiImage } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

interface DashboardCardProps {
  icon: IconType;
  title: string;
  description: string;
  onClick: () => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ icon, title, description, onClick }) => (
    <Flex
        direction="column"
        align="center"
        justify="center"
        bg="gray.700"
        boxShadow="lg"
        borderRadius="lg"
        p={6}
        cursor="pointer"
        transition="transform 0.2s"
        _hover={{ transform: "scale(1.05)", boxShadow: "xl" }}
        textAlign="center"
        onClick={onClick}
    >
      <Box bg="teal.600" p={4} borderRadius="full" mb={4}>
        <Icon as={icon} boxSize={8} color="white" />
      </Box>
      <Heading size="md" mb={2} color="white">
        {title}
      </Heading>
      <Text color="gray.300">{description}</Text>
    </Flex>
);

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
      <Box p={10} bg="gray.800" minH="100vh">
        <Heading mb={8} textAlign="center" color="teal.300">
          Dashboard
        </Heading>
        <Stack direction={{ base: "column", md: "row" }} spacing={8} justify="center">
          <DashboardCard
              icon={FiCamera}
              title="Create or Edit Product Photos"
              description="Generate and manage AI-powered product photography."
              onClick={() => navigate("/c-panel/cartario/products/images")}
          />
          <DashboardCard
              icon={FiImage}
              title="Create or Edit Theme Images"
              description="Create and customize theme images for your store."
              onClick={() => navigate("/c-panel/cartario/theme/images")}
          />
        </Stack>
      </Box>
  );
};

export default Dashboard;
